import { createContext, useContext, useState, useCallback } from "react";

const LeadModalContext = createContext(null);

export function LeadModalProvider({ children }) {
	const [open, setOpen] = useState(false);
	const [prefill, setPrefill] = useState({});

	const openLeadModal = useCallback((opts = {}) => {
		setPrefill(opts);
		setOpen(true);
	}, []);

	const closeLeadModal = useCallback(() => setOpen(false), []);

	return (
		<LeadModalContext.Provider value={{ open, prefill, openLeadModal, closeLeadModal }}>
			{children}
		</LeadModalContext.Provider>
	);
}

export const useLeadModal = () => useContext(LeadModalContext);
